import React, { useState } from 'react';
import Hero from '../../organisms/Hero';
import HowWorks from '../../organisms/HowHipagesWorks';
import { trackEvent } from '../../utils';
import qs from 'querystring';
import Helmet from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { useSelector } from 'react-redux';
import { getCategoryDetails, getModalQuestionsByCategory } from '../../selectors';
import { Redirect } from 'react-router-dom';
import { GetQuotesModal } from 'hui';
import { useSetupSeoMetrics } from '../../utils/snowplow';

const getHeroTitle = (path, category) => {
  if (path === '/find/:category/get_quotes_simple') {
    return `We have ${category} ready to help you.`;
  } else {
    return `We have tradies ready to help you.`;
  }
};

const getPageTitle = (path, category) => {
  if (path.includes('category')) {
    return `Get Free ${category} Quotes - Australia`;
  }
  return 'hipages - Change the way you tradie';
};

const GQSimple: React.FC<RouteComponentProps<{ category?: string }>> = props => {
  const { location, match } = props;
  const { path, url, params } = match;
  const { search_str: queryCategory, w: initialLocation } = qs.parse(location.search.slice(1));
  const routeCategory = params.category;

  //get state category and questions if path has category
  const stateCategoryDetails = useSelector(state => {
    return getCategoryDetails(state);
  });
  const stateModalQuestions = useSelector(state => {
    return getModalQuestionsByCategory(state);
  })[routeCategory];
  const category = routeCategory ? routeCategory : queryCategory;

  //fallback questions to open empty modal if something unexpected happens
  const fallbackCategoryDetails = {
    key: category ? category : '',
    personPlural: 'tradies',
    id: ''
  };
  const fallbackQuestions = { questions: [], tree: [] };
  const [modalData, setModalData] = useState({
    categoryDetails: stateCategoryDetails.key ? stateCategoryDetails : fallbackCategoryDetails,
    questions: stateModalQuestions ? stateModalQuestions : fallbackQuestions,
    isOpen: !!routeCategory
  });
  const setIsOpen = (value: boolean) => {
    setModalData({ ...modalData, isOpen: value });
  };
  const { key, personPlural, id } = modalData.categoryDetails;
  const heroData = {
    title: getHeroTitle(path, personPlural),
    setModalData,
    initialValue: key ? key : '',
    fallbackQuestions: modalData.questions,
    fallbackCategoryDetails: modalData.categoryDetails,
    heroImage: stateCategoryDetails.thumbnail
  };

  //datalayer and SEO contruction
  const metaName = stateCategoryDetails.name ? ` ${stateCategoryDetails.name}` : '';
  const metaPersonPlural = stateCategoryDetails.personPlural
    ? stateCategoryDetails.personPlural
    : 'tradies';
  const pageTitle = getPageTitle(path, metaName);
  const seoMetrics = {
    canonicalLink: `https://hipages.com.au${location.pathname}`,
    h1: getHeroTitle(path, personPlural),
    h2: `what customers say about hipages`,
    metaDescription: `Get${metaName} quotes from 3 reliable ${metaPersonPlural}. Free service, fast responses and no obligation to hire.`,
    title: `Get Free${metaName} Quotes - Australia | hipages.com.au`,
    seoName: stateCategoryDetails.name,
    siteSection: 'Get Quotes',
    siteSubsection: 'Get Quotes category',
    targetKeyword: '',
    robots: ''
  };
  useSetupSeoMetrics(seoMetrics);

  if (routeCategory && !stateCategoryDetails.name) {
    return <Redirect to={`/get_quotes_simple?search_str=${routeCategory}`} />;
  }

  return (
    <>
      {pageTitle && (
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={seoMetrics.metaDescription} />
          <meta property="og:title" content={seoMetrics.title} />
          <meta property="og:description" content={seoMetrics.metaDescription} />
        </Helmet>
      )}
      <Hero {...heroData} />
      <HowWorks isHidingAction={true} />
      {modalData.isOpen && (
        <GetQuotesModal
          questions={modalData.questions}
          categoryId={id}
          category={key}
          categoryPlural={personPlural}
          skipLocationStep={false}
          open={modalData.isOpen}
          setOpen={setIsOpen}
          trackEvent={trackEvent.bind(this)}
          pathName={url}
          initialLocation={initialLocation}
        />
      )}
    </>
  );
};

export default GQSimple;
